import { render, staticRenderFns } from "./IndicadoresHistoricoVentasMixClientes.vue?vue&type=template&id=67973e16&"
import script from "./IndicadoresHistoricoVentasMixClientes.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoVentasMixClientes.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoVentasMixClientes.vue?vue&type=style&index=0&id=67973e16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports